import { IFuelRate } from '../../interfaces/ifuel-rate';
import { UnitOfMeasure } from '../unit-of-measure';
import { Vendor } from '../vendor';

export class FuelRateBase {
  FuelRateId: number;
  VendorId: number;
  DrillingItemId: number;
  UnitRate: number;
  UnitOfMeasureId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  UnitOfMeasure?: UnitOfMeasure;
  Vendor?: Vendor;

  constructor(item?: IFuelRate) {
    if (item) {

      this.FuelRateId = item.FuelRateId;
      this.VendorId = item.VendorId;
      this.DrillingItemId = item.DrillingItemId;
      this.UnitRate = item.UnitRate;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
      this.Vendor = new Vendor(item.Vendor);
    }
  }
}